import React from 'react';

import { logSyncContainerConfiguration } from '@totem/components/administration/logSync/containerConfiguration';
import LogSyncContainer from '@totem/components/administration/logSync/LogSyncContainer';
import {
  LogSyncExtra,
  LogSyncLayout,
} from '@totem/components/administration/logSync/LogSyncLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';

const LogSyncPage = () => (
  <ContentLayout>
    <InputContainer
      filterConfig={logSyncContainerConfiguration}
      defaultSort={{ field: 'createdAt', direction: 'descend' }}
      defaultPageSize={20}
      componentKey={'dashboard.admin.logSync'}
      componentLabel={'Admin: Log Sync Results'}
    >
      <LogSyncContainer>
        <IBCard isCovered title="Log Sync Results" extra={<LogSyncExtra />}>
          <LogSyncLayout />
        </IBCard>
      </LogSyncContainer>
    </InputContainer>
  </ContentLayout>
);

export default LogSyncPage;
